module.exports = __webpack_public_path__ + "static/media/maze.27a41177.gif";